module.exports = __webpack_public_path__ + "static/img/preview-01.e4c88d43.webp";